import { render, staticRenderFns } from "./enGradingPaper.vue?vue&type=template&id=66c4c938&scoped=true"
import script from "./enGradingPaper.vue?vue&type=script&lang=js"
export * from "./enGradingPaper.vue?vue&type=script&lang=js"
import style0 from "./enGradingPaper.vue?vue&type=style&index=0&id=66c4c938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c4c938",
  null
  
)

export default component.exports